import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, FunctionField, RichTextField } from 'react-admin';
import {
  useListContext,
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
} from 'react-admin';
import { Button as CButton, Box } from '@material-ui/core';
import { PreviewImage, UpLoadFile } from './custom/UpLoadFile';
import { ArrowBack, Search } from '@material-ui/icons';
import RichTextInput from 'ra-input-rich-text';
//import ResetOrderNum from './S_xumu_fangyibaogao_ResetOrderNum';

import {
  useRefresh,
  useNotify,
  useUnselectAll,
  useUpdateMany,

  Confirm,
} from 'react-admin';
import { Info } from '@material-ui/icons';
import { useState } from 'react';
import { apiUrl } from '../global';

{/* 
  import { S_xumu_fangyibaogaoList, S_xumu_fangyibaogaoCreate, S_xumu_fangyibaogaoEdit, S_xumu_fangyibaogaoShow } from './components/S_xumu_fangyibaogao';

  <Resource name="CMSS_xumu_fangyibaogao" list={S_xumu_fangyibaogaoList} create={S_xumu_fangyibaogaoCreate} edit={S_xumu_fangyibaogaoEdit} show={S_xumu_fangyibaogaoShow} />
  <Resource name="CMSS_xumu_fangyibaogao" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles({
  imageField: {
    '& img': { width: 60 }
  },
});

const useTxtData = {
  page: {
    tableName: 'S_xumu_fangyibaogao',
  },
  table: {
    id: 'id',
    fangyiTitle: '方案标题',
    fangyiContent: '方案内容',
    AtTime: '更新时间',
  }
};

//分页列表页面
export const S_xumu_fangyibaogaoList = (props) => {
  //筛选器模块
  // const Filters = (props) => {
  //   return (
  //     <Filter {...props}>
  //       <TextInput label="ID" source="id" alwaysOn resettable />
  //       {/* <TextInput label="XX" source="name" alwaysOn resettable /> */}
  //     </Filter>
  //   );
  // };
  const Filters = (props) => {
    const { displayedFilters, filterValues, setFilters, hideFilter, } = useListContext();
    if (props.context === "button") return null;
    const onSubmit = values => { if (Object.keys(values).length > 0) { setFilters(values); } else { setFilters({}, []); } };
    const resetFilter = () => { setFilters({}, []); };
    return (
      <div>
        <Form onSubmit={onSubmit} initialValues={filterValues}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box display='flex' alignItems='center'>
                <Box component="span" mr={2}>
                  <TextInput label="ID" source="id" alwaysOn resettable />
                </Box>
                <Box component="span" mr={2} mb={2.5}>
                  <CButton variant="contained" color="primary" type="submit" startIcon={<Search />}>搜索</CButton>
                </Box>
                <Box component="span" mr={2} mb={2.5}>
                  <CButton variant="outlined" onClick={resetFilter}>重置</CButton>
                </Box>
              </Box>
            </form>
          )}
        </Form>
      </div>
    );
  };

  const ResetOrderNum = (props) => {
    const { label, basePath, selectedIds } = props;
    const basePathName = basePath.replace('/', '');
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();

    const [updateMany, { loading }] = useUpdateMany(
      basePathName,
      selectedIds,
      { payload: 'ResetOrderNum', data: { OrderNum: 0 } },
      {
        onSuccess: () => {
          refresh();
          notify('操作成功');
          unselectAll(basePathName);
        },
        onFailure: (error) => notify('执行失败', 'warning'),
      }
    );

    const [open, setOpen] = useState(false);
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
      updateMany();
      handleDialogClose();
    };
    return (
      <Fragment>
        <Button label={label} disabled={loading} onClick={handleClick}>
          <Info />
        </Button>
        <Confirm
          isOpen={open}
          loading={loading}
          title="确认操作"
          content="确定要执行该操作吗？"
          onConfirm={handleConfirm}
          onClose={handleDialogClose}
        />
      </Fragment>
    );
  };

  //批量操作模块
  const AssetBulkActionButtons = (props) => {
    return (
      <Fragment>
        <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" />
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = (props) => {
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton {...props} /><br />
        <ShowButton {...props} /><br />
        <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" />
        {/* <ResetOrderNum label="下载报告" {...props} /> */}
        <br />
        <a target='_blank' label={'下载报告'} href={`${apiUrl}/Admin/CMSS_xumu_fangyibaogao/DownloadOne?id=${props.record.id}`} >下载报告</a>
      </div>
    );
  }

  const classes = useStyles();
  return (
    <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<Filters />} bulkActionButtons={<AssetBulkActionButtons />} >
      <Datagrid>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.fangyiTitle} source="fangyiTitle" />
        {/* <TextField label={useTxtData.table.fangyiContent} source="fangyiContent" /> */}
        <FunctionField label={useTxtData.table.fangyiContent} render={({ fangyiContent }) => {
          // 假设 content 是你从数据库拿到的那长串带标签的内容
          const rawContent = fangyiContent;
          // 1. 去掉 HTML 标签
          const cleanText = rawContent.replace(/<[^>]+>/g, '');
          // 2. 截取前 200 个字并加上省略号
          const shortContent = cleanText.length > 200
            ? cleanText.substring(0, 200) + '...'
            : cleanText;
          return <div>{shortContent}</div>
        }
        } />
        <TextField label={useTxtData.table.AtTime} source="AtTime" />
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const S_xumu_fangyibaogaoShow = (props) => {
  const ShowActions = (props) => {
    const { basePath, data } = props; const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
        <EditButton basePath={basePath} record={data} />
      </TopToolbar>
    );
  };

  const classes = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.fangyiTitle} source="fangyiTitle" />
        <RichTextField label={useTxtData.table.fangyiContent} source="fangyiContent" />
        <TextField label={useTxtData.table.AtTime} source="AtTime" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const S_xumu_fangyibaogaoEdit = (props) => {
  const PostEditActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    );
  };
  return (
    <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const S_xumu_fangyibaogaoCreate = (props) => {
  const PostCreateActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text" >
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = (props) => {
    const { basePath } = props;
    return (
      <Toolbar {...props}>
        <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
        <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
      </Toolbar>
    );
  };

  return (
    <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      {/* <TextInput label={useTxtData.table.id} source="id" validate={[required()]} /> */}
      <TextInput label={useTxtData.table.fangyiTitle} source="fangyiTitle" validate={[required()]} />
      <RichTextInput label={useTxtData.table.fangyiContent} source="fangyiContent" validate={[required()]} />
      {/* <TextInput label={useTxtData.table.AtTime} source="AtTime" validate={[required()]} /> */}
    </SimpleForm>
  );
}